var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supplier" },
    [
      _c(
        "el-card",
        [
          _c("z-search", {
            ref: "search",
            attrs: {
              showNumCheck: false,
              configs: _vm.searchConfigs,
              isResetDoReloadData: false,
            },
            on: {
              "do-query": function ($event) {
                return _vm.getListData(_vm.params)
              },
              "do-reset": function ($event) {
                return _vm.getListData(_vm.params)
              },
            },
            model: {
              value: _vm.params,
              callback: function ($$v) {
                _vm.params = $$v
              },
              expression: "params",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-card",
            [
              _c(
                "div",
                { staticClass: "mb-16" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "stores::supplier::add",
                          expression: "'stores::supplier::add'",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.addNewSupplier },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("supplier::add_button")) + " ")]
                  ),
                ],
                1
              ),
              _c("z-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "table",
                attrs: {
                  data: _vm.list,
                  "max-height": 540,
                  columns: _vm.columns,
                  pagination: _vm.pagination,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                  "page-change": _vm.getListData,
                },
                scopedSlots: _vm._u([
                  {
                    key: "status",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === 0
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.editText.status_off)),
                            ])
                          : _vm._e(),
                        row.status === 1
                          ? _c("span", [_vm._v(_vm._s(_vm.editText.status_on))])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "options",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "stores::supplier::edit",
                                expression: "'stores::supplier::edit'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleEdit(row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.editText.table_edit) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "stores::supplier::detail",
                                expression: "'stores::supplier::detail'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleDetail(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.editText.table_detail) + " "
                            ),
                          ]
                        ),
                        row.status === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "stores::supplier::onOff",
                                    expression: "'stores::supplier::onOff'",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleOpen(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.editText.status_on) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        row.status === 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "stores::supplier::onOff",
                                    expression: "'stores::supplier::onOff'",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleStop(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.editText.status_off) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.addNewModal
        ? [
            _c("editDialog", {
              attrs: {
                id: _vm.modalId,
                isNew: _vm.isNew,
                formData: _vm.editModalForm,
              },
              on: { getListData: _vm.getListData },
              model: {
                value: _vm.addNewModal,
                callback: function ($$v) {
                  _vm.addNewModal = $$v
                },
                expression: "addNewModal",
              },
            }),
          ]
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.detailModal,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailModal = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "detailModalForm",
              staticClass: "detailDialog",
              attrs: { "label-suffix": "：", "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "name",
                    label: _vm.$t("supplier::table_name"),
                  },
                },
                [_vm._v(" " + _vm._s(_vm.detailModalForm.name) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "contacts",
                    label: _vm.$t("supplier::table_staff"),
                  },
                },
                [_vm._v(" " + _vm._s(_vm.detailModalForm.contacts) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "phone",
                    label: _vm.$t("supplier::table_phone"),
                  },
                },
                [_vm._v(" " + _vm._s(_vm.detailModalForm.phone) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "area", label: _vm.$t("supplier::form_area") },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.detailModalForm.province) +
                      _vm._s(_vm.detailModalForm.city) +
                      _vm._s(_vm.detailModalForm.area) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "address",
                    label: _vm.$t("supplier::form_address"),
                  },
                },
                [_vm._v(" " + _vm._s(_vm.detailModalForm.address) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "email",
                    label: _vm.$t("supplier::form_email"),
                  },
                },
                [_vm._v(" " + _vm._s(_vm.detailModalForm.email) + " ")]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailModal = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }